export default "__VITE_ASSET__d8ea0ef5__"